const drupalToTealium = () => {
  document.addEventListener('drupalInit', () => {
    // drupalSettings is ready
    window.drupalSettings.tealium = {
      page_type: 'accounts',
    };
    // dispatch the ga4 event data ready to tealium
    const event = new CustomEvent('ga4_event_ready', {
      detail: {
        status: 'ready',
        page_type: window.drupalSettings.tealium.page_type,
      },
    });
    document.dispatchEvent(event);
  });
};

export default drupalToTealium;
